import * as jQuery from '../../dependencies/node_modules/jquery'

export const $ = jQuery;
export const $jqBody = jQuery('body');
export const $jqHtml = jQuery('html');
export const Pages = {
    'HOME'      : 'home-page',
    'GALLERY'   : 'gallery-page',
};
